var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{key:_vm.key,ref:"duration",class:_vm.reactiveClass,attrs:{"size":"sm","placeholder":"0.0"},on:{"change":_vm.saveDuration},model:{value:(_vm.form.activity_duration),callback:function ($$v) {_vm.$set(_vm.form, "activity_duration", $$v)},expression:"form.activity_duration"}})
}
var staticRenderFns = []

export { render, staticRenderFns }